(function () {
  var C = window.HLC_CURRENT || null;
  var I = window.HLC_I18N || {};
  var t = function (k, fb) { return I[k] != null ? I[k] : fb; };
  var $ = function (id) { return document.getElementById(id); };
  // Opening unit comes from the entry (US carriers publish inches). The section
  // renders the inputs already in this unit, so the two must not disagree.
  var unit = window.HLC_UNIT === 'in' ? 'in' : 'cm';

  function nums(s) { return (String(s || '').match(/\d+(?:\.\d+)?/g) || []).map(Number).slice(0, 3); }
  // Stored limits are floored to 0.1 cm (the floor rule: never round a limit up).
  // On an inch-native carrier that means 22 in is stored as 55.8, not 55.88 — so a
  // strict comparison rejects a bag at exactly the airline's own published limit.
  // Compare at the same 0.1 cm granularity the limits are stored in. This absorbs
  // the flooring artefact only: a real 0.9 cm overage still fails.
  var EPS = 0.1;
  function fits(b, l) {
    if (b.length < 3 || l.length < 3) return false;
    b = b.slice().sort(function (a, c) { return a - c; });
    l = l.slice().sort(function (a, c) { return a - c; });
    return b[0] <= l[0] + EPS && b[1] <= l[1] + EPS && b[2] <= l[2] + EPS;
  }
  // Canonical bag dims in cm — the source of truth for verdicts. Toggling the unit
  // only reformats the inputs; it never re-rounds the canonical values (a 55 cm bag
  // must not flip verdicts after cm -> in -> cm round-tripping).
  var cmVals = null;
  var toCm = function (v) { return unit === 'cm' ? v : v * 2.54; };
  function syncFromInputs() {
    var h = +$('h').value, w = +$('w').value, d = +$('d').value;
    cmVals = (!h || !w || !d) ? null : [toCm(h), toCm(w), toCm(d)];
  }
  function readCm() { return cmVals; }

  // Show a "40 × 30 × 20 cm" string in the active unit.
  // Converted limits are FLOORED (never rounded up): a rounded-up inch figure
  // invites packing over the cm limit the airline enforces.
  // On an inch-native carrier the stored cm value is already our floored conversion
  // of the airline's own inches, so flooring again would print 17.9 for a limit the
  // airline publishes as 18. There we round to nearest, which reconstructs the
  // published figure and can never exceed it. Elsewhere the floor rule stands.
  var nativeIn = window.HLC_UNIT === 'in';
  function toIn(v) {
    return nativeIn ? Math.round(v / 2.54 * 10) / 10 : Math.floor(v / 2.54 * 10) / 10;
  }
  function showDims(s) {
    var n = nums(s); if (n.length < 3) return s;
    if (unit === 'cm') return n[0] + ' × ' + n[1] + ' × ' + n[2] + ' cm';
    return n.map(toIn).join(' × ') + ' in';
  }
  // Show a "10 kg" string in the active unit (kg -> lb with inches).
  function showWeight(s) {
    if (!s) return '';
    var m = String(s).match(/\d+(?:\.\d+)?/);
    if (!m) return s;
    if (unit === 'cm') return s;
    var _lb = nativeIn ? Math.round(parseFloat(m[0]) * 2.20462) : Math.floor(parseFloat(m[0]) * 2.20462);
    return _lb + ' lb';
  }

  function render() {
    var dims = readCm(); drawBag(dims);
    var el = $('result'); if (!el || !C) return;
    if (!dims) { el.innerHTML = '<div class="hlc-empty">' + t('empty', 'Enter height, width and depth to see the result.') + '</div>'; return; }
    // Some carriers (Delta, Southwest) publish no personal item dimensions at all.
    // On their personal-item page there is nothing to grade against, so the tool
    // stays but names the absence instead of quietly falling through to the cabin
    // tier — inventing a reference figure would be the dishonest alternative.
    var hasPersonal = nums(C.personal).length === 3;
    var cls, label, detail;
    if (window.HLC_ROLE === true && !hasPersonal) {
      el.className = 'hlc-result hlc-nolimit';
      el.innerHTML =
        '<span class="hlc-pill nolimit">' + t('noLimit', 'No limit published') + '</span>' +
        '<div class="hlc-detail">' + t('noLimitD', '') + '</div>' +
        '<div class="hlc-limits"><span><b>' + t('cabinLabel', 'Cabin:') + '</b> ' + showDims(C.cabin) + '</span></div>';
      return;
    }
    if (hasPersonal && fits(dims, nums(C.personal))) { cls = 'pass'; label = t('fitsFree', 'Fits free'); detail = t('detFree', 'Goes in as the free personal item.'); }
    else if (fits(dims, nums(C.cabin))) {
      cls = 'paid'; label = t('fitsPaid', 'Fits the paid bag');
      detail = hasPersonal ? t('detPaid', 'Too big for the free allowance, but fits the paid cabin bag.')
                           : t('detPaidNoPi', t('detPaid', ''));
    }
    else { cls = 'fail'; label = t('noFit', "Doesn't fit"); detail = t('detFail', 'Over even the cabin bag. It travels in the hold.'); }
    var wt = showWeight(C.weight);
    // Only print the personal-item limit when there is one: showDims on an empty
    // field rendered the literal string "null" in the card.
    var limits = '';
    if (hasPersonal) {
      limits += '<span><b>' + t('freeLabel', 'Free:') + '</b> ' + showDims(C.personal) + '</span>';
    }
    limits += '<span><b>' + t('cabinLabel', 'Cabin:') + '</b> ' + showDims(C.cabin) + (wt ? ' · ' + wt : '') + '</span>';
    el.className = 'hlc-result hlc-' + cls;
    el.innerHTML =
      '<span class="hlc-pill ' + cls + '"><span class="dot"></span>' + label + '</span>' +
      '<div class="hlc-detail">' + detail + '</div>' +
      '<div class="hlc-limits">' + limits + '</div>';
  }

  function drawBag(dims) {
    var svg = $('bagsvg'); if (!svg) return;
    if (!dims) { svg.innerHTML = ''; $('vizcap').textContent = ''; return; }
    var H = dims[0], W = dims[1], D = dims[2], max = Math.max(H, W, D), s = 120 / max;
    var w = W * s, h = H * s, dp = D * s * 0.5;
    var ox = (200 - (w + dp)) / 2, oy = (200 - (h + dp)) / 2 + dp;
    var p = function (x, y) { return x.toFixed(1) + ',' + y.toFixed(1); };
    svg.innerHTML =
      '<polygon points="' + p(ox, oy) + ' ' + p(ox + dp, oy - dp) + ' ' + p(ox + w + dp, oy - dp) + ' ' + p(ox + w, oy) + '" fill="#f3f3f3" stroke="#1a1a1a" stroke-width="1"/>' +
      '<polygon points="' + p(ox + w, oy) + ' ' + p(ox + w + dp, oy - dp) + ' ' + p(ox + w + dp, oy - dp + h) + ' ' + p(ox + w, oy + h) + '" fill="#e5e3df" stroke="#1a1a1a" stroke-width="1"/>' +
      '<rect x="' + ox + '" y="' + oy + '" width="' + w + '" height="' + h + '" fill="#faf9f7" stroke="#1a1a1a" stroke-width="1.2"/>';
    $('vizcap').textContent = unit === 'cm'
      ? Math.round(H) + ' × ' + Math.round(W) + ' × ' + Math.round(D) + ' cm'
      : (H / 2.54).toFixed(1) + ' × ' + (W / 2.54).toFixed(1) + ' × ' + (D / 2.54).toFixed(1) + ' in';
  }

  function setUnit(u) {
    if (u === unit) return;
    unit = u;
    ['h', 'w', 'd'].forEach(function (id, i) {
      if (cmVals) $(id).value = u === 'in' ? +(cmVals[i] / 2.54).toFixed(1) : +cmVals[i].toFixed(1);
    });
    $('uCm').classList.toggle('on', u === 'cm'); $('uIn').classList.toggle('on', u === 'in');
    [].forEach.call(document.querySelectorAll('[data-u]'), function (e) { e.textContent = u; });
    render();
  }

  function init() {
    if (!$('result')) return;
    $('uCm').onclick = function () { setUnit('cm'); };
    $('uIn').onclick = function () { setUnit('in'); };
    ['h', 'w', 'd'].forEach(function (id) {
      $(id).addEventListener('input', function () { syncFromInputs(); render(); });
    });
    syncFromInputs();
    render();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
